<kendo-grid
    [kendoGridBinding]="matrixData"
    [pageSize]="20"
    [filterable]="true"
    [pageable]="true"
    [sortable]="true"
    [groupable]="false"
    [reorderable]="true"
    [resizable]="true"
    [height]="height"
    [selectable]="false">

    <kendo-grid-command-column *ngIf="canEdit || canDelete" title=" " [width]="100" [filterable]="false" [sortable]="false">
        <ng-template kendoGridHeaderTemplate>
            
        <button *ngIf="canEdit && !readonly" (click)="openEdit()"><mat-icon [svgIcon]="'heroicons_outline:plus-circle'"></mat-icon></button>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
            <div class="flex">
                <button *ngIf="canEdit && !readonly" kendoButton [svgIcon]="editSVG" (click)="openEdit(dataItem)" [title]="'grid.button.editRecord' | transloco"></button>
                <button *ngIf="canDelete && !readonly" kendoButton [svgIcon]="deleteSVG" (click)="deleteActivity(dataItem)" [title]="'grid.button.deleteRecord' | transloco"></button>
            </div>
        </ng-template>
    </kendo-grid-command-column>

    <kendo-grid-column *ngFor="let column of gridColumns" [field]="column.field" [title]="column.title | transloco"
                       [width]="column.width" [hidden]="column.hidden" [sortable]="column.sort"
                       [format]="column.format" [ngClass]="column.cssClass" [filter]="column.filter" [sortable]="true">
        <ng-template kendoGridCellTemplate let-dataItem>
            <ng-container *ngIf="column.fieldType === 'FILE'; else defaultTemplate">
                <!--<a [hidden]="dataItem[column.field].isExternal" [href]="getFileUrl(dataItem, column.field)" [attr.download]="getFileName(dataItem, column.field)" class="download-link">
                    {{getFileName(dataItem, column.field)}}
                    <svg class="icon w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="5" height="5" fill="none" viewBox="0 0 24 24">
                      <path stroke="var(--custom-color)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"/>
                    </svg>
                  </a>-->
                  <button class="style-button" (click)="downloadFile(dataItem[column.field])">{{getFileName(dataItem, column.field)}}
                    <mat-icon style="color:var(--custom-color)">cloud_download</mat-icon>
                </button>
                  <div [hidden]="!dataItem[column.field].isExternal">{{getFileName(dataItem, column.field)}}</div>

                  
                
            </ng-container>
            
            <ng-template #defaultTemplate>
                <ng-container *ngIf="column.fieldType === 'DROPDOWN' || column.fieldControlType === 'DROPDOWNLIST'; else dateTemplate">
                    {{getTextValue(dataItem, column.field)}}   <!--DATAITEM-->
                </ng-container>
            </ng-template>
            <ng-template  #dateTemplate>
                <ng-container *ngIf="column.fieldType === 'DATETIME'; else htmltemplate">
                    {{getFormattedDate(dataItem[column.field])}}
                </ng-container>
            </ng-template>
            <ng-template  #htmltemplate>
                <ng-container *ngIf="column.fieldControlType === 'HTML'; else colortemplate">
                    <div [innerHTML]="sanitizeHtml(dataItem[column.field])"></div>
                </ng-container>
            </ng-template>
            <ng-template  #colortemplate>
                <ng-container *ngIf="column.fieldControlType === 'COLORPICKER'; else locationtemplate">
                    <span [innerHTML]="getColorSquare(dataItem[column.field]?.value)"></span>
                    {{dataItem[column.field]?.value}}
                </ng-container>
            </ng-template>

            <ng-template #locationtemplate>
                <ng-container *ngIf="column.fieldControlType === 'FULL'; else objectTemplate">
                    <div style="display: flex; align-items: center;">
                        <span *ngIf="dataItem[column.field]?.description"
                              title="Lat: {{dataItem[column.field]?.lat}}, Lon: {{dataItem[column.field]?.lon}}">
                            <button kendoButton [svgIcon]="markerSVG" 
                            style=" 
                            background: none;
                            border: none;
                            padding: 0;
                            margin: 0; 
                            cursor: default;
                            line-height: 0;
                            box-shadow: none;
                            ">
                            </button>
                        </span>
                        <span style="margin-left: 8px;">{{dataItem[column.field]?.description}}</span>
                    </div>
                </ng-container>
            </ng-template>
            
            
            <ng-template #objectTemplate>
                <ng-container *ngIf="column.fieldControlType === 'CODEEDITOR'; else normalTemplate">
                {{ dataItem[column.field] }}
                </ng-container>
            </ng-template>

            <ng-template #normalTemplate>
                {{ dataItem[column.field] }}
            </ng-template>
        </ng-template>
        
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
            <ng-container [ngSwitch]="column.filter">
                
                <ng-container *ngSwitchCase="'dropdownlist'">
                    <kendo-dropdownlist
                        [data]="dropdownOptions[column.field]"
                        [filterable]="true"
                        textField="text"
                        valueField="value"
                        (valueChange)="onFilterChange($event, column)"
                        [valuePrimitive]="true"
                        [(ngModel)]="column.filterValue">
                    </kendo-dropdownlist>
                </ng-container>

                <ng-container *ngSwitchCase="'html'">
                    <kendo-grid-string-filter-cell
                        [column]="column" 
                        [filter]="filter">
                    </kendo-grid-string-filter-cell>
                </ng-container>

                <ng-container *ngSwitchCase="'colorPicker'">
                    <kendo-dropdownlist
                      [data]="dropdownOptions[column.field]"
                      [filterable]="true"
                      textField="text"
                      valueField="value"
                      (valueChange)="onFilterChange($event, column)"
                      [valuePrimitive]="true"
                      [(ngModel)]="column.filterValue">
                  
                      <ng-template kendoDropDownListItemTemplate let-dataItem>
                        <span [innerHTML]="getColorSquare(dataItem.value)"></span>
                        {{dataItem.text}}
                      </ng-template>
                  
                      <ng-template kendoDropDownListValueTemplate let-dataItem>
                        <ng-container *ngIf="dataItem && dataItem.value">
                          <span [innerHTML]="getColorSquare(dataItem.value)"></span>
                          {{dataItem.text}}
                        </ng-container>
                      </ng-template>
                  
                    </kendo-dropdownlist>
                  </ng-container>
                  
                  
                  

                <ng-container *ngSwitchCase="'numeric'">
                    <kendo-grid-numeric-filter-cell kendoGridFilterInput
                        [column]="column"
                        [filter]="filter">
                    </kendo-grid-numeric-filter-cell>
                </ng-container>

                <ng-container *ngSwitchCase="'decimal'">
                    <kendo-grid-numeric-filter-cell kendoGridFilterInput
                        [column]="column"
                        [filter]="filter"
                        [format]="column.format">
                    </kendo-grid-numeric-filter-cell>
                </ng-container>

                <ng-container *ngSwitchCase="'date'">
                    <kendo-grid-date-filter-cell [value]="value"
                    [column]="column"
                    [filter]="filter"
                    (filterChange)="onDateFilterChange($event, column)"
                    [format]="format">
                </kendo-grid-date-filter-cell>
                </ng-container>

                <ng-container *ngSwitchCase="'text'">
                    <kendo-grid-string-filter-cell
                        [column]="column" 
                        [filter]="filter">
                    </kendo-grid-string-filter-cell>
                </ng-container>

                <ng-container *ngSwitchCase="'location'">
                    <kendo-autocomplete 
                        [(ngModel)]="searchQuery" 
                        [data]="searchResults" 
                        [valueField]="'formatted_address'" 
                        (input)="onSearch($event.target.value)"
                        (valueChange)="onSearchSelect($event)">
                    </kendo-autocomplete>
                </ng-container>

                <ng-container *ngSwitchCase="'array'">
                    <kendo-grid-string-filter-cell
                        [column]="column" 
                        [filter]="filter">
                    </kendo-grid-string-filter-cell>
                </ng-container>
                  
                
                <ng-container *ngSwitchCase="'codeEditor'">
                    <kendo-grid-string-filter-cell
                        [column]="column" 
                        [filter]="filter">
                    </kendo-grid-string-filter-cell>
                </ng-container>

                <ng-container *ngSwitchDefault>
                    <input kendoGridFilterInput [column]="column" [filter]="filter" />
                </ng-container>
            </ng-container>
        </ng-template>
    </kendo-grid-column>

</kendo-grid>
